import { render, staticRenderFns } from "./myDialogPc.vue?vue&type=template&id=56d1d34c&scoped=true"
import script from "./myDialogPc.vue?vue&type=script&lang=js"
export * from "./myDialogPc.vue?vue&type=script&lang=js"
import style0 from "./myDialogPc.vue?vue&type=style&index=0&id=56d1d34c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1d34c",
  null
  
)

export default component.exports